/**
 * Guest-visible money formatting for Mews-sourced amounts (no client-side FX).
 * Uses Intl; CHF defaults to Swiss locale for conventional grouping/symbol placement.
 */
export function formatBookMoney(
  value: number,
  currencyCode: string,
  locale?: string
): string {
  if (!Number.isFinite(value)) {
    return "";
  }
  const code = currencyCode.trim().toUpperCase();
  if (!code) {
    return "";
  }
  const resolvedLocale =
    locale !== undefined
      ? locale
      : code === "CHF"
        ? "de-CH"
        : undefined;

  return new Intl.NumberFormat(resolvedLocale, {
    style: "currency",
    currency: code,
  }).format(value);
}
